import {
  CapacitorUpdater,
  FlexibleUpdateInstallStatus,
} from '@capgo/capacitor-updater';
import { useEffect } from 'react';

import { getPlatform } from '@/shared/utils/platform';

export function useOnFlexibleUpdateDownloaded(listener: () => void) {
  useEffect(() => {
    // only Android supports flexible updates
    if (getPlatform() !== 'ANDROID') return;

    const listenerPromise = CapacitorUpdater.addListener(
      'onFlexibleUpdateStateChange',
      ({ installStatus }) => {
        if (installStatus === FlexibleUpdateInstallStatus.DOWNLOADED) {
          listener();
        }
      },
    );
    return () => {
      void listenerPromise.then(listener => listener.remove());
    };
  }, [listener]);
}
